'use client';

import { displayPlainText } from '@/utils/stripHtmlForTooltip';

/**
 * Renders setting-15 breed-average captions as plain text.
 * ILR2 may ship `<b>` around Black/Red; we strip tags so detail, grid, and
 * percentages pages match without `dangerouslySetInnerHTML`.
 */
export default function Ilr2CaptionText({ raw }: { raw: string }) {
  return <span>{displayPlainText(raw)}</span>;
}
